import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import Swal from "sweetalert2";
import { API_BASE } from "./config";

export default function AbsensiTableClockIn() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [rangeType, setRangeType] = useState("today"); 

  const [users, setUsers] = useState([]);
  const [view, setView] = useState("rekap"); 

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/users`);
        setUsers(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchUsers();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/clock_in`);
      setData(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (rangeType === "custom") return;

    const today = new Date();
    let start, end;

    if (rangeType === "today") {
      start = end = today.toISOString().split("T")[0];
    } else if (rangeType === "week") {
      const firstDay = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - today.getDay()
      );
      const lastDay = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - today.getDay() + 6
      );
      start = firstDay.toISOString().split("T")[0];
      end = lastDay.toISOString().split("T")[0];
    } else if (rangeType === "month") {
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      start = firstDay.toISOString().split("T")[0];
      end = lastDay.toISOString().split("T")[0];
    } else if (rangeType === "year") {
      const firstDay = new Date(today.getFullYear(), 0, 1);
      const lastDay = new Date(today.getFullYear(), 11, 31);
      start = firstDay.toISOString().split("T")[0];
      end = lastDay.toISOString().split("T")[0];
    }

    setStartDate(start);
    setEndDate(end);
  }, [rangeType]);

  useEffect(() => {
    let filtered = data.filter((item) => {
      const tgl = item.waktu.split(" ")[0];
      return tgl >= startDate && tgl <= endDate;
    });

    const earliestMap = {};
    filtered.forEach((item) => {
      const nama = item.nama;
      const waktu = item.waktu;
      if (!earliestMap[nama] || waktu < earliestMap[nama].waktu) {
        earliestMap[nama] = item;
      }
    });

    setFilteredData(
      Object.values(earliestMap).filter(
        (item) =>
          item.nama.toLowerCase().includes(search.toLowerCase()) ||
          item.status.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [data, search, startDate, endDate]);

  const [showModal, setShowModal] = useState(false);
  const [formAdd, setFormAdd] = useState({
    nama: "",
    departemen: "",
    lokasi: "",
    status: "",
  });

  const [editingRowId, setEditingRowId] = useState(null);
  const [editFormData, setEditFormData] = useState({});
  const startEditing = (row) => {
    setEditingRowId(row.id);
    setEditFormData({ ...row });
  };

  const cancelEditing = () => {
    setEditingRowId(null);
    setEditFormData({});
  };
  const saveEdit = async (id) => {
    try {
      await axios.put(`${API_BASE}/api/clock_in/${id}`, editFormData);
      setEditingRowId(null);
      fetchData();
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Yakin hapus data ini?",
      text: "Data yang dihapus tidak bisa dikembalikan!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Ya, hapus!",
      cancelButtonText: "Batal",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${API_BASE}/api/clock_in/${id}`);
          fetchData();
          Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
        } catch (err) {
          console.error(err);
          Swal.fire("Error", "Gagal menghapus data.", "error");
        }
      }
    });
  };

  const getDuplicateNames = () => {
    const rangeData = data.filter(
      (item) =>
        item.waktu.split(" ")[0] >= startDate &&
        item.waktu.split(" ")[0] <= endDate
    );
    const countMap = {};
    rangeData.forEach((item) => {
      countMap[item.nama] = (countMap[item.nama] || 0) + 1;
    });
    return Object.keys(countMap).filter((nama) => countMap[nama] > 1);
  };

  const duplicateNames = getDuplicateNames();

  const columns = [
    { name: "No", selector: (row, index) => index + 1, width: "70px" },
    {
      name: "Nama",
      cell: (row) =>
        editingRowId === row.id ? (
          <select
            value={editFormData.nama}
            onChange={(e) => {
              const selectedUser = users.find((u) => u.nama === e.target.value);
              setEditFormData({
                ...editFormData,
                nama: selectedUser.nama,
                departemen: selectedUser.departemen,
              });
            }}
            className="border px-1 py-0.5"
          >
            <option value="">-- Pilih User --</option>
            {users.map((u) => (
              <option key={u.id} value={u.nama}>
                {u.nama}
              </option>
            ))}
          </select>
        ) : (
          row.nama
        ),
      sortable: true,
    },
    {
      name: "Departemen",
      cell: (row) =>
        editingRowId === row.id ? (
          <input
            value={editFormData.departemen}
            readOnly
            className="border px-1 py-0.5 bg-gray-100"
          />
        ) : (
          row.departemen
        ),
      sortable: true,
    },
    { name: "Lokasi", selector: (row) => row.lokasi, sortable: true },
    { name: "Tanggal", selector: (row) => row.waktu.split(" ")[0], sortable: true },
    { name: "Jam", selector: (row) => row.waktu.split(" ")[1], sortable: true },
    {
      name: "Status",
      cell: (row) =>
        editingRowId === row.id ? (
          <select
            value={editFormData.status}
            onChange={(e) =>
              setEditFormData({ ...editFormData, status: e.target.value })
            }
            className="border px-1 py-0.5"
          >
            <option value="Cuti">Cuti</option>
            <option value="Izin">Izin</option>
            <option value="Sakit">Sakit</option>
            <option value="Terlambat">Terlambat</option>
            <option value="Tepat Waktu">Tepat Waktu</option>
          </select>
        ) : (
          row.status
        ),
      sortable: true,
    },
    {
      name: "Aksi",
      cell: (row) =>
        editingRowId === row.id ? (
          <div className="flex gap-2">
            <button
              onClick={() => saveEdit(row.id)}
              className="bg-green-500 text-white px-2 py-1 rounded"
            >
              Simpan
            </button>
            <button
              onClick={cancelEditing}
              className="bg-gray-400 text-white px-2 py-1 rounded"
            >
              Batal
            </button>
          </div>
        ) : (
          <div className="flex gap-2">
            <button
              onClick={() => startEditing(row)}
              className="bg-yellow-500 text-white px-2 py-1 rounded"
            >
              Edit
            </button>
            <button
              onClick={() => handleDelete(row.id)}
              className="bg-red-500 text-white px-2 py-1 rounded"
            >
              Hapus
            </button>
          </div>
        ),
    },
  ];

  return (
    <div className="p-2">
      <div className="flex flex-wrap items-center justify-between mb-4">
        <div className="flex gap-2">
          <button
            onClick={() => setView("rekap")}
            className={`px-3 py-1 rounded ${
              view === "rekap" ? "bg-blue-600 text-white" : "bg-gray-200"
            }`}
          >
            Rekap
          </button>
          <button
            onClick={() => setView("history")}
            className={`px-3 py-1 rounded ${
              view === "history" ? "bg-blue-600 text-white" : "bg-gray-200"
            }`}
          >
            History
          </button>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <select
            value={rangeType}
            onChange={(e) => setRangeType(e.target.value)}
            className="border px-2 py-1 rounded"
          >
            <option value="today">Hari ini</option>
            <option value="week">Minggu ini</option>
            <option value="month">Bulan ini</option>
            <option value="year">Tahun ini</option>
            <option value="custom">Custom</option>
          </select>

          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="border px-2 py-1 rounded"
          />

          <span>-</span>

          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="border px-2 py-1 rounded"
          />

          <input
            type="text"
            placeholder="🔍 Cari nama atau status..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border px-2 py-1 rounded w-64"
          />

          <button
            onClick={() => setShowModal(true)}
            className="flex items-center justify-center bg-green-600 hover:bg-green-700 
              text-white w-7 h-7 rounded text-xl font-bold shadow-md transition"
          >
            <span className="relative -top-0.5">+</span>
          </button>
        </div>
      </div>

      <DataTable
        title={view === "rekap" ? "📋 Rekap Clock In" : "📜 History Clock In"}
        columns={columns}
        data={
          view === "rekap"
            ? filteredData
            : data.filter(
                (item) =>
                  item.waktu.split(" ")[0] >= startDate &&
                  item.waktu.split(" ")[0] <= endDate &&
                  (
                    item.nama.toLowerCase().includes(search.toLowerCase()) ||
                    item.status.toLowerCase().includes(search.toLowerCase())
                  )
              )
        }
        pagination
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 25, 50, 100]}
        highlightOnHover
        striped
        conditionalRowStyles={[
          {
            when: (row) =>
              view === "history" && duplicateNames.includes(row.nama),
            style: {
              backgroundColor: "#FEE2E2", 
              color: "#B91C1C", 
            },
          },
        ]}
      />

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-4 rounded w-96 z-1000">
            <h2 className="text-lg font-bold mb-2">Tambah Clock In</h2>

            <label className="block text-sm mb-1">Nama</label>
            <select
              value={formAdd.nama}
              onChange={(e) => {
                const selectedUser = users.find(
                  (u) => u.nama === e.target.value
                );
                setFormAdd({
                  ...formAdd,
                  nama: selectedUser ? selectedUser.nama : "",
                  departemen: selectedUser ? selectedUser.departemen : "",
                });
              }}
              className="border w-full px-2 py-1 mb-2"
            >
              <option value="">-- Pilih User --</option>
              {users.map((u) => (
                <option key={u.id} value={u.nama}>
                  {u.nama}
                </option>
              ))}
            </select>

            <label className="block text-sm mb-1">Departemen</label>
            <input
              type="text"
              value={formAdd.departemen}
              readOnly
              className="border w-full px-2 py-1 mb-2 bg-gray-100"
            />

            <label className="block text-sm mb-1">Lokasi</label>
            <input
              type="text"
              value={formAdd.lokasi}
              onChange={(e) =>
                setFormAdd({ ...formAdd, lokasi: e.target.value })
              }
              placeholder="Lokasi"
              className="border w-full px-2 py-1 mb-2"
            />

            <label className="block text-sm mb-1">Status</label>
            <select
              value={formAdd.status}
              onChange={(e) =>
                setFormAdd({ ...formAdd, status: e.target.value })
              }
              className="border w-full px-2 py-1 mb-2"
            >
              <option value="Cuti">Cuti</option>
              <option value="Izin">Izin</option>
              <option value="Sakit">Sakit</option>
            </select>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowModal(false)}
                className="bg-gray-400 text-white px-3 py-1 rounded"
              >
                Batal
              </button>
              <button
                onClick={async () => {
                  try {
                    const waktu = new Date()
                    .toLocaleString("sv-SE", { timeZone: "Asia/Jakarta" })
                    .replace("T", " ");
                    await axios.post(`${API_BASE}/api/clock_in`, {
                      ...formAdd,
                      status: formAdd.status || "Cuti",
                      waktu,
                    });
                    setShowModal(false);
                    setFormAdd({
                      nama: "",
                      departemen: "",
                      lokasi: "",
                      status: "Cuti",
                    });
                    fetchData();
                  } catch (err) {
                    console.error(err);
                  }
                }}
                className="bg-green-600 text-white px-3 py-1 rounded"
              >
                Simpan
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
